import axios from "axios";

export function autoLoginAPI() {
  const metaData = {
    withCredentials: true,
  };

  return doLogin(metaData);
}

export function loginAPI(action) {
  const email = action.email;
  const password = action.password;
  const basicAuth = "Basic " + btoa(`${email}:${password}`);

  const metaData = {
    headers: {
      Authorization: basicAuth,
    },
    withCredentials: true,
  };

  return doLogin(metaData);
}

function doLogin(metaData) {

  return new Promise((resolve) => {
    axios
      .get(`${process.env.REACT_APP_BACKEND}/applogin`, metaData)
      .then((response) => {
        const token = response.headers["x-xsrf"];
        axios.defaults.headers["X-CSRF-TOKEN"] = token;
        resolve(response.status);
      })
      .catch((e) => {
        if (e.response) {
          resolve(e.response.status);
        } else {
          resolve(400);
        }
      });
  });
}
